// Hero.js
import React, { useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Hero.css';
import heroImg from '../assets/home4.jpg'; // IMPORT the image


function Hero() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: false, mirror: true });
  }, []);

  const bgStyle = {
    backgroundImage: `linear-gradient(120deg, rgba(2,0,36,0.4), rgba(0,0,0,0.55)), url(${heroImg})`,
    backgroundPosition: 'center center',
    backgroundSize: 'cover',   // cover keeps the section filled and looks good on all viewports
    backgroundRepeat: 'no-repeat',
  };

  return (
    <section id="hero" className="hero-section" style={bgStyle}>
      <div className="overlay"></div>

      <div className="position-relative text-white text-center" data-aos="fade-up">
        <h1 className="fw-bold mb-3 " data-aos="fade-right">
          <span>D</span><span className="text-danger">2</span><span>D E<span className="text-danger">X</span>PRESS</span>
        </h1>

        <p className="lead mb-4 hero-subtitle" data-aos="fade-left">
          Delivering your goods safely and on time — across the globe.
        </p>

<Link
  to="/tracking"
  className="btn btn-success btn-lg rounded-pill shadow hero-btn"
  data-aos="zoom-in"
>
  Track your order
</Link>

      </div>
    </section>
  );
}

export default Hero;
